// extracted by mini-css-extract-plugin
module.exports = {"inline-notification":"non-cat-equipment-banner-client_inline-notification__llSUd"};